module.exports = __webpack_public_path__ + "static/media/info2.dfa4e6ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/info2.png
// module id = 389
// module chunks = 0